export const doctorIdConstants = {
  SET_DOCTOR_ID: 'SET_DOCTOR_ID',
};
